export default {
  title: "快捷键说明",
  userHelp: "用户帮助",
  canvasOperationTip: {
    title: "画布操作提示",
    tooltip: "画布操作节点时的步骤提示",
  },
  reopenUserGuide: "再看一遍用户引导",
  shortcuts: {
    selectAll: {
      label: "全选",
      key: "ctrl+A/⌘+A",
    },
    multiSelect: {
      label: "多选",
      key: "ctrl/⌘+鼠标左键选择多个节点",
    },
    boxSelect: {
      label: "多选框选",
      key: "鼠标右键框选多个节点",
    },
    previousStep: {
      label: "上一步",
      key: "ctrl+Z/⌘+Z",
    },
    nextStep: {
      label: "下一步",
      key: "ctrl+F/⌘+F",
    },
    expandDetails: {
      label: "展开详情",
      description: " (节点/交易边详情)",
      key: "ctrl+E/⌘+E",
    },
    saveCanvas: {
      label: "保存画布",
      key: "alt+S/⌥+S",
    },
    nodeRemark: {
      label: "节点备注",
      description: " (选中至少一个节点)",
      key: "alt+V/⌥+V",
    },
    copyAddress: {
      label: "复制地址",
      description: " (选中至少一个节点)",
      key: "ctrl+C/⌘+C",
    },
    deleteNode: {
      label: "删除节点",
      description: " (选中至少一个节点)",
      key: "Delete",
    },
    newCanvas: {
      label: "新建画布",
      description: " (选中至少一个节点)",
      key: "alt+G/⌥+G",
    },
    addMonitor: {
      label: "加入监控",
      description: " (选中一个节点)",
      key: "ctrl+M/⌘+M",
    },
    directAssociation: {
      label: "直接关联",
      description: " (选中多个节点)",
      key: "ctrl+R/⌘+R",
    },
    batchExpand: {
      label: "批量扩展",
      description: " (选中多个节点)",
      key: "enter/return",
    },
  },
};
